import { useContext, useEffect, useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { UserModuleContext } from "../../context/UserModuleContext";

export const usePersonInfo = (identifier) => {
    const [state, setState] = useState({ isLoaded: false, error: null });
    const { authState } = useOktaAuth();
    const { userModule, setUserModule } = useContext(UserModuleContext);

    useEffect(() => {
        if (!userModule.isOpen) return;

        const fetchPersonInfo = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT}/user/info`,
                    {
                        method: "POST",
                        headers: {
                            Authorization: authState.accessToken.accessToken,
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        },
                        body: JSON.stringify({ userId: identifier }),
                    }
                );

                if (!response.ok) {
                    let message = `Request failed with status ${response.status}`;
                    try {
                        const errorData = await response.json();
                        message = errorData?.error?.message || errorData?.message || message;
                    } catch { /* not JSON */ }
                    throw new Error(message);
                }

                const result = await response.json();

                setUserModule((prev) => ({
                    ...prev,
                    isRestricted: result["Restricted From Modification In Tech Tools"],
                    isLoaded: true,
                    userData: result,
                }));

                setState({ isLoaded: true, error: null });
            } catch (error) {
                setState({ isLoaded: true, error });
            }
        };

        fetchPersonInfo();
    }, [userModule.isOpen, identifier, authState.accessToken.accessToken, setUserModule]);

    return state;
};
